<template>
  <div
    ref="container"
    :class="clzName"
    @click.stop="clickContainer()"
  />
</template>

<script>
import Cropper from './cropper-web';
import { compressImage, getUploadImageHash } from 'src/local-logic/tip-match/create/group-qrcode';

export default {
  name: 'tip-match-upload-img-web.vue',
  components: {},
  props: {
    autoUpload: {
      type: Boolean,
      default: true,
    },
    needCrop: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: Number,
      default: 1,
    },
    outputType: {
      type: String,
      default: 'png',
    },
    centerBox: {
      type: Boolean,
      default: false,
    },
    clzName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      option: {
        img: '',
        outputType: 'png',
        autoCropWidth: 0,
        autoCropHeight: 0,
        mode: '375px auto',
      },
      input: null,
      compressFile: null,
      croppedData: null,
    };
  },
  mounted() {
    this.initOption();
    this.initInput();
  },
  methods: {
    initOption() {
      const cropWidth = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth;
      this.option.autoCropWidth = cropWidth;
      this.option.autoCropHeight = Math.floor(cropWidth * this.aspectRatio);
      this.option.mode = `${cropWidth}px auto`;
      this.option.outputType = this.outputType;
      this.option.centerBox = this.centerBox;
      this.option.aspectRatio = this.aspectRatio;
    },
    initInput() {
      const input = document.createElement('input');
      input.style.visibility = 'hidden';
      input.type = 'file';// 添加file类型
      input.accept = 'image/*';
      input.style.height = '100%';
      input.style.width = '100%';
      input.id = 'inputfile';
      this.$refs.container.appendChild(input);

      const that = this;
      input.onchange = (event) => {
        const file = event.target.files[0];
        that.onSelectFile(file, input);
      };
      this.input = input;
    },
    onSelectFile(file) {
      if (this.needCrop) {
        this.cropImage(file);
      } else {
        this.compressImage(file)
          .then((file) => {
            this.compressFile = file;
            this.$emit('imageSelected', file);
            if (this.autoUpload) {
              this.uploadCompressFile();
            }
          })
          .catch((err) => {
            this.uploadFail(err);
          })
          .finally(() => {
          });
      }
    },
    uploadCompressFile(file) {
      this.$emit('startUpload');
      getUploadImageHash(file || this.compressFile, this.uploadSuccess);
    },
    cropImage(file) {
      const reader = new FileReader();
      const that = this;
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        that.option.img = data;
        Cropper.show({
          option: that.option,
          doCropAndUpload: that.doCropAndUpload,
        });
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    doCropAndUpload(data) {
      this.croppedData = data;
      this.$emit('imageCropped', data);
      if (this.autoUpload) {
        this.uploadCroppedData();
      }
    },
    uploadCroppedData() {
      this.$emit('startUpload');
      getUploadImageHash(this.croppedData, this.uploadSuccess, true);
    },
    compressImage(file) {
      return compressImage(file);
    },
    uploadSuccess(data) {
      this.$emit('uploadSuccess', data);
      this.input.value = '';
    },
    uploadFail(err) {
      this.$emit('uploadFail', err);
      this.input.value = '';
    },
    clickContainer() {
      if (this.input) {
        this.input.click();
      }
    },
  },
};
</script>

<style scoped>
.prize-image-selector {
  width: 1.12rem;
  height: 1.12rem;
  margin-right: .46rem;
  margin-bottom: .4rem;
  position: absolute;
}
.team-avatar-select {
  width: 1.2rem;
  height: 1.2rem;
}
</style>
